import React from 'react';
import './Loader.css';

function Loader() {
	return (
		<span className="bouncingLoader">
			<span></span>
			<span></span>
			<span></span>
		</span>
	);
}

Loader.propTypes = {};

export default Loader;
